import { FC, ReactElement } from 'react';

import { Skeleton, Wrapper } from '../../../../../../../components';
import { generateIdArray } from '../../../../../../../helpers/array';

import './ProductImagesSkeletons.scss';

interface ProductImagesSkeletonsProps {
    className?: string;
}

export const ProductImagesSkeletons: FC<ProductImagesSkeletonsProps> = ({
    className = '',
}): ReactElement => {
    const imageSkeletons = generateIdArray(6);

    return (
        <div className={`product-images-skeletons ${className}`}>
            <Wrapper className="product-images-skeletons__details-wrapper">
                <div className="product-images-skeletons__details-image-list">
                    {imageSkeletons.map(skeleton => (
                        <div key={skeleton} className="product-images-skeletons__details-image-item">
                            <Skeleton className="product-images-skeletons__details-image" />
                        </div>
                    ))}
                </div>
            </Wrapper>
        </div>
    );
};
